module.exports = __webpack_public_path__ + "static/img/construct3.3b878fc5.png";